// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/DotGothic16-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/PressStart2P-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/PixelifySans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/GohuFont14NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../fonts/BigBlueTerm437NerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../fonts/HeavyDataNerdFont-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DotGothic16";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"); }

@font-face {
  font-family: "Press Start 2P";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

@font-face {
  font-family: "Pixelify Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }

@font-face {
  font-family: "Gohu";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }

@font-face {
  font-family: "Big Blue";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }

@font-face {
  font-family: "Heavy Data";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }

:root {
  --main-font: "Pixelify Sans", sans-serif;
  --clock-font: "DotGothic16", sans-serif;
  --log-in-font: "Press Start 2P", sans-serif;
  --Gohu-test: "Gohu", sans-serif;
  --Big-Blue-test: "Big Blue", sans-serif;
  --Heavy-Data-test: "Heavy Data", sans-serif; }

.moveable-modal {
  position: absolute;
  border: 1px solid #cccccc;
  background-color: white;
  z-index: 1000;
  width: 30vw;
  max-width: 650px;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  flex-direction: column;
  overflow: hidden; }
  @media screen and (max-width: 430px) {
    .moveable-modal {
      transform: translate(-50%, -50%);
      width: 99%;
      max-width: none;
      left: 50%;
      top: 55%; } }

.modal-header {
  background-color: #d0d0d0;
  display: flex;
  flex-direction: column; }
  .modal-header * {
    font-weight: bold; }

.title-x-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start; }

.title-bar {
  background-color: #011E75;
  color: white;
  width: 100%;
  padding: 5px 10px;
  border-top: 1px white solid;
  border-right: 1px black solid;
  border-bottom: 1px black solid;
  border-left: 1px white solid;
  margin-top: 2px;
  font-family: var(--main-font); }
  .title-bar:hover {
    cursor: move; }

.close {
  width: 40px;
  height: 40px;
  margin-left: 5px; }

.close-btn {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  right: 0; }
  .close-btn.invisible {
    display: none; }

.close-btn-hover {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  right: 0; }

.name-tab-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 95%;
  padding: 10px;
  overflow-x: auto; }
  .name-tab-div > div {
    font-size: medium; }
  @media screen and (max-width: 430px) {
    .name-tab-div {
      width: 400px; } }

.name-tab {
  border-bottom: 1px transparent solid;
  max-width: 110px;
  text-wrap: nowrap;
  padding: 0px 5px;
  font-family: var(--main-font); }
  .name-tab:hover {
    cursor: default;
    border-bottom: 1px gray solid; }
  .name-tab.match {
    border-bottom: 1px black solid; }
  @media screen and (max-width: 430px) {
    .name-tab {
      margin: 0px 10px; } }

.modal-content {
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column; }

.close {
  float: right;
  cursor: default; }

.invisible {
  display: none; }
`, "",{"version":3,"sources":["webpack://./src/components/style_imports/_fonts.scss","webpack://./src/components/MoveableModal/MoveableModal.scss"],"names":[],"mappings":"AAAA;EACI,0BAA0B;EAC1B,+DAAkE,EAAA;;AAGtE;EACI,6BAA6B;EAC7B,4CAAgD,EAAA;;AAGpD;EACI,4BAA4B;EAC5B,4CAAgD,EAAA;;AAGpD;EACI,mBAAmB;EACnB,4CAAsD,EAAA;;AAG1D;EACI,uBAAuB;EACvB,4CAA0D,EAAA;;AAG9D;EACI,yBAAyB;EACzB,4CAAqD,EAAA;;AAGzD;EACI,wCAAY;EACZ,uCAAa;EACb,2CAAc;EACd,+BAAY;EACZ,uCAAgB;EAChB,2CAAkB,EAAA;;AClCtB;EACI,kBAAkB;EAClB,yBAAoC;EACpC,uBAAoC;EACpC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EAEnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAA;EAEhB;IAbJ;MAcQ,gCAAgC;MAChC,UAAU;MAEV,eAAe;MACf,SAAS;MACT,QAAQ,EAAA,EAEf;;AAED;EACI,yBAAyB;EACzB,aAAa;EACb,sBAAsB,EAAA;EAH1B;IAMQ,iBAAiB,EAAA;;AAIzB;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB,EAAA;;AAG3B;EACI,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EAEf,6BAA6B,EAAA;EAXjC;IAcQ,YAAY,EAAA;;AAIpB;EACI,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAA;;AAGpB;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ,EAAA;EALZ;IAQQ,aAAa,EAAA;;AAIrB;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ,EAAA;;AAGZ;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,gBAAgB,EAAA;EANpB;IASQ,iBAAiB,EAAA;EAIrB;IAbJ;MAcQ,YAAY,EAAA,EAGnB;;AAED;EACI,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAEhB,6BAA6B,EAAA;EANjC;IASQ,eAAe;IACf,6BAA6B,EAAA;EAVrC;IAcQ,8BAA8B,EAAA;EAGlC;IAjBJ;MAkBQ,gBAAgB,EAAA,EAGvB;;AAED;EAGI,wBAAmB;EAAnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAA;;AAG1B;EACI,YAAY;EACZ,eAAe,EAAA;;AAGnB;EACI,aAAa,EAAA","sourcesContent":["@font-face {\n    font-family: \"DotGothic16\";\n    src: url(\"../../fonts/DotGothic16-Regular.ttf\") format(\"truetype\");\n}\n\n@font-face {\n    font-family: \"Press Start 2P\";\n    src: url(\"../../fonts/PressStart2P-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Pixelify Sans\";\n    src: url(\"../../fonts/PixelifySans-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Gohu\";\n    src: url(\"../../fonts/GohuFont14NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Big Blue\";\n    src: url(\"../../fonts/BigBlueTerm437NerdFont-Regular.ttf\");\n}\n\n@font-face {\n    font-family: \"Heavy Data\";\n    src: url(\"../../fonts/HeavyDataNerdFont-Regular.ttf\");\n}\n\n:root {\n    --main-font: \"Pixelify Sans\", sans-serif;\n    --clock-font: \"DotGothic16\", sans-serif;\n    --log-in-font: \"Press Start 2P\", sans-serif;\n    --Gohu-test: \"Gohu\", sans-serif;\n    --Big-Blue-test: \"Big Blue\", sans-serif;\n    --Heavy-Data-test: \"Heavy Data\", sans-serif;\n}","@import '../style_imports/fonts';\n\n.moveable-modal {\n    position: absolute;\n    border: 1px solid rgb(204, 204, 204);\n    background-color: rgb(255, 255, 255);\n    z-index: 1000;\n    width: 30vw;\n    max-width: 650px;\n    height: fit-content;\n    // height: 70vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    @media screen and (max-width: 430px) {\n        transform: translate(-50%, -50%);\n        width: 99%;\n        // height: 50vh;\n        max-width: none;\n        left: 50%;\n        top: 55%;\n    }\n}\n\n.modal-header {\n    background-color: #d0d0d0;\n    display: flex;\n    flex-direction: column;\n\n    & * {\n        font-weight: bold;\n    }\n}\n\n.title-x-div {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.title-bar {\n    background-color: #011E75;\n    color: white;\n    width: 100%;\n    padding: 5px 10px;\n    border-top: 1px white solid;\n    border-right: 1px black solid;\n    border-bottom: 1px black solid;\n    border-left: 1px white solid;\n    margin-top: 2px;\n\n    font-family: var(--main-font);\n\n    &:hover {\n        cursor: move;\n    }\n}\n\n.close {\n    width: 40px;\n    height: 40px;\n    margin-left: 5px;\n}\n\n.close-btn {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    &.invisible {\n        display: none;\n    }\n}\n\n.close-btn-hover {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n.name-tab-div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 95%;\n    padding: 10px;\n    overflow-x: auto;\n\n    &>div {\n        font-size: medium;\n    }\n\n\n    @media screen and (max-width: 430px) {\n        width: 400px;\n        // overflow-x: scroll;\n    }\n}\n\n.name-tab {\n    border-bottom: 1px transparent solid;\n    max-width: 110px;\n    text-wrap: nowrap;\n    padding: 0px 5px;\n\n    font-family: var(--main-font);\n\n    &:hover {\n        cursor: default;\n        border-bottom: 1px gray solid;\n    }\n\n    &.match {\n        border-bottom: 1px black solid;\n    }\n\n    @media screen and (max-width: 430px) {\n        margin: 0px 10px;\n    }\n\n}\n\n.modal-content {\n    // height: 100%;\n    // height: 65vh;\n    height: fit-content;\n    width: 100%;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.close {\n    float: right;\n    cursor: default;\n}\n\n.invisible {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
